import { cellStyle } from "../../components/Table/Table.styles";
import { roundToTwo } from "../../services/utils/roundToTwo";
import Avatar from "../../assets/Avatar.svg";

// define your columns
export const getColumns = (token: string) => {
  return [
    {
      title: "Member",
      field: "name",
      cellStyle: cellStyle,
      render: (member: any) => {
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={`${process.env.REACT_APP_API_URL}/members/${member.id}/photo?authorization=${token}`}
              onError={event => {
                event.currentTarget.src = Avatar;
                event.currentTarget.onerror = () => undefined;
              }}
              style={{
                marginRight: "9.22px",
                height: "32px",
                width: "40px",
                borderRadius: "7px",
                objectFit: "cover",
              }}
            />
            <span
              style={{
                fontWeight: "600" as any,
                lineHeight: "18px",
                color: "#373F41",
              }}
            >
              {member.name}
            </span>
          </div>
        );
      },
    },
    {
      title: "Team",
      field: "teamName",
      cellStyle: cellStyle,
    },
    {
      title: "Role",
      field: "roleName",
      cellStyle: cellStyle,
    },
    {
      title: "Team Members",
      field: "directReports",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      render: (member: any) => {
        return roundToTwo(parseFloat(member.directReports));
      },
    },
    {
      title: "Score",
      field: "score",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      render: (member: any) => {
        return roundToTwo(parseFloat(member.score));
      },
    },
    {
      title: "Check-ins Completed",
      field: "checkIns",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      customSort: (a: any, b: any) => {
        return (parseInt(a.checkins) || 0) - (parseInt(b.checkins) || 0);
      },
    },
    {
      title: "OT/Wk Last 30",
      field: "overtimeHours",
      type: "numeric",
      align: "left",
      cellStyle: cellStyle,
      render: (member: any) => {
        return Math.round(member.overtimeHours).toLocaleString();
      },
    },
  ];
};
